var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFHUnisex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 200,
    viewBox: "0 0 130 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3693 199.99C28.0183 187.61 28.9578 174.658 30.983 162.152C31.4737 159.008 32.0896 155.884 32.6115 152.751C33.0813 149.617 33.4571 146.415 34.6681 143.417C35.7955 140.409 37.3405 137.557 38.9273 134.743C40.4827 132.046 42.3931 129.077 41.4223 125.924C41.0673 123.858 40.5976 121.316 40.3366 119.453L40.2426 119.239V119.22L40.2322 119.2C40.2322 119.152 38.3531 111.022 38.374 110.983C37.7372 107.461 36.3488 100.369 35.6494 96.8468H36.1191L34.9708 102.668C34.6994 104.026 34.2401 106.442 33.9269 107.771C33.8434 107.995 33.8121 108.324 33.6764 108.538L32.8621 109.906L32.883 109.848C30.7951 118.065 27.6842 126.079 23.5816 133.618C19.9696 140.215 14.5308 149.335 10.6265 155.884C10.7204 155.584 10.1776 157.747 10.1985 157.708C10.3968 159.581 10.5743 162.113 10.9605 164.16C11.8061 168.468 13.0901 172.718 13.2676 177.113L13.5704 180.382C13.7896 181.488 13.1841 182.614 12.944 183.652L12.8814 183.448C14.917 185.088 14.917 187.969 13.7165 190.046L13.6226 190.24L13.4033 190.152C9.39465 188.639 6.31507 185.369 3.65306 182.497C0.886663 180.343 0.656999 176.627 0.176794 173.678L0.0202049 173.086L0.00976562 173.038V172.989C0.218551 171.767 0.813588 169.108 1.02237 167.954C1.23116 166.964 1.96191 160.6 2.16025 159.445C5.26071 149.791 7.53647 139.963 10.2507 130.212C12.2863 122.926 14.1758 115.465 17.934 108.732C21.5668 101.979 22.1514 94.2272 23.4772 86.8632C24.4794 80.6345 25.1475 74.3766 26.087 68.1478C27.1309 62.3944 31.5467 59.2994 37.7163 59.2994C39.7311 59.0957 43.7607 58.6203 45.7754 58.4457C47.0073 58.2807 48.6358 57.8635 49.544 57.4463C52.728 55.1566 53.4692 51.1788 54.1164 47.6957C54.0955 47.8509 54.1582 44.5425 54.1477 44.5619C54.2521 44.8821 50.8907 36.8584 50.9011 36.8875C49.21 35.7329 47.9468 32.4924 47.2161 30.3094C46.4436 27.9518 45.6293 25.1382 47.4249 22.994C48.0094 21.9365 47.8633 20.617 47.9572 19.3848C48.5001 15.6495 48.7089 11.8948 49.9929 8.29528C53.1664 0.941053 62.9271 -1.66882 70.5269 1.04778C73.0114 1.86276 75.663 3.25987 76.5817 5.70481C77.9597 7.98481 79.1184 10.5753 79.8492 13.1658C80.6321 15.7659 80.7469 18.4728 81.6969 21.0342L82.3128 22.9746C82.4485 23.6344 82.8243 24.2068 82.8348 24.983C82.5425 26.3607 82.1562 27.622 81.7491 28.9317C80.8513 31.5028 80.0371 34.1903 78.0432 36.2763C77.2185 39.2354 75.0575 43.0581 75.329 46.609C75.402 50.1794 76.9992 53.6916 79.6091 56.3015C81.6238 57.4949 84.7347 57.8053 87.3341 58.0188C89.7143 58.3292 93.0966 58.6203 95.4767 58.8823C101.657 59.8428 104.026 65.2566 104.361 70.4957C105.624 80.3919 106.918 90.8023 109.215 100.534C110.207 105.588 113.401 109.828 115.144 114.631C117.013 119.414 118.297 124.362 119.675 129.262C122.42 139.1 124.717 149.015 127.828 158.746C128.12 160.832 128.82 166.848 129.3 168.905L129.968 172.262V172.31C129.509 173.998 129.456 175.861 128.924 177.637C128.538 179.179 127.546 180.799 126.325 181.77C123.548 184.758 120.583 187.863 116.554 189.425L116.334 189.512L116.24 189.318C115.019 187.222 115.082 184.389 117.076 182.72L117.013 182.924C116.762 181.886 116.167 180.761 116.376 179.655L116.668 176.385C117.023 169.807 119.539 163.53 119.748 156.922V156.99L119.278 155.079L119.31 155.147C113.109 144.465 105.603 133.084 101.135 121.713C99.5167 117.813 98.5876 113.699 97.6585 109.634C97.4497 109.285 96.6042 108.441 96.2805 107.733L96.6772 107.8L96.6355 107.839L96.4163 108.043C93.7647 103.367 93.0131 97.7394 90.7373 92.9465L90.6642 92.7719L91.1236 92.7136C90.5494 96.9244 90.2258 101.164 89.9126 105.404C89.422 111.759 89.2445 118.153 88.0962 124.44C87.9187 126.526 88.3049 128.641 89.2758 130.533C91.2175 134.413 92.6477 138.479 94.2971 142.437L95.9256 148.297L95.8212 148.161C95.9047 148.21 96.03 148.307 96.0613 148.462C96.0822 148.637 96.0196 148.753 95.9465 148.841L95.9882 148.647L96.9487 152.12C98.1805 160.056 99.9238 167.944 100.675 175.958C101.448 183.943 101.448 192.054 100.467 199.99C102.523 183.943 99.6524 167.944 96.5415 152.197C96.5728 152.314 95.5289 148.734 95.5289 148.763L95.4976 148.666L95.5707 148.569V148.559C95.5916 148.53 95.5916 148.511 95.5916 148.54C95.5916 148.559 95.602 148.559 95.5707 148.54L95.4872 148.491L95.4663 148.404C95.4663 148.404 93.8169 142.457 93.8482 142.573C92.1884 138.605 90.7791 134.559 88.8478 130.717C87.8456 128.767 87.4385 126.555 87.6264 124.401C89.4011 113.893 89.161 103.202 90.6642 92.6457L90.7791 91.7822C91.468 93.2958 92.1466 94.8675 92.6477 96.4684C93.9004 100.029 94.9026 104.22 96.6877 107.539L96.3223 107.509L96.3641 107.471L96.6146 107.238C96.9278 108.053 97.6063 108.645 98.1283 109.46C99.1096 113.544 99.9969 117.648 101.615 121.548C106.073 132.881 113.61 144.3 119.769 154.943V154.972L120.228 156.874V156.913C120.03 163.539 117.514 169.817 117.149 176.414L116.856 179.693C116.648 180.78 117.263 181.808 117.504 182.944C115.541 184.515 115.52 187.096 116.668 189.114L116.355 189.007C118.297 188.241 120.04 187.106 121.596 185.786C123.172 184.457 124.56 182.944 125.97 181.449C128.632 179.305 128.778 175.89 129.31 172.853V172.834L129.467 172.242V172.339L128.788 168.973C128.308 166.896 127.63 161.026 127.316 158.795C124.237 149.248 121.898 139.119 119.174 129.368C117.128 122.024 115.228 114.582 111.397 107.849C107.858 100.931 107.231 93.092 105.906 85.6311L104.809 78.0925C103.859 73.2317 104.392 67.75 101.751 63.3647C100.362 61.2399 98.003 59.7263 95.3514 59.3189C93.0757 59.0763 89.5785 58.7464 87.2402 58.4554C84.5259 58.2225 81.6447 57.9897 79.2437 56.6217C78.5547 55.9619 77.9179 55.2051 77.4064 54.4096C74.6504 50.5384 74.1076 45.5515 75.6839 41.1758C76.3416 39.4198 77.0619 37.7801 77.6047 35.9852C80.3711 32.9678 81.3628 28.6989 82.4172 24.9345C82.4277 24.3426 82.0623 23.6829 81.9266 23.0328L81.3315 21.0924C80.4129 18.5407 80.3085 15.795 79.5569 13.1949C78.847 10.5947 77.7613 8.09153 76.3729 5.73391C75.9658 4.55025 75.0575 3.57033 73.9927 2.82327C66.2155 -2.27036 53.8554 -0.33963 50.1391 8.32438C49.283 10.6723 49.0012 13.1852 48.688 15.6495C48.5523 16.8817 48.3331 18.143 48.2287 19.3654C48.1347 20.5879 48.3331 21.8977 47.6858 23.1105C46.9238 24.1486 46.5271 25.3128 46.6732 26.5547C47.3622 30.0669 48.5418 34.1321 51.3187 36.6935L54.5862 44.4455L54.6071 44.4843V44.5231L54.5653 47.7054C54.5653 47.7054 54.5653 47.7345 54.5653 47.7442C53.9076 51.3437 53.1038 55.3701 49.8259 57.7568C47.6545 58.8629 44.1991 58.9987 41.7772 59.2606L37.7372 59.7069C29.271 59.8137 26.515 64.6842 25.9722 71.9122C25.4085 76.9185 24.6464 81.9054 23.9157 86.8923C22.5794 94.2854 21.9844 102.096 18.3202 108.907C14.5725 115.62 12.7039 123.013 10.6787 130.3C7.97491 140.031 5.67828 149.888 2.58826 159.542C2.34816 161.395 1.58609 167.721 1.12677 169.681L0.448214 173.047V172.95C1.1894 176.142 1.03281 179.868 3.92448 182.148C6.69089 185.107 9.57212 188.202 13.539 189.725L13.2259 189.832C14.3742 187.795 14.3429 185.243 12.3907 183.662C12.6308 182.517 13.2572 181.488 13.038 180.411L12.7352 177.142C12.5369 174.959 12.3281 172.785 11.8896 170.651C10.7726 166.392 9.91662 162.035 9.66607 157.64C9.66607 157.64 10.1463 155.719 10.1358 155.7C10.1358 155.681 10.1567 155.651 10.1672 155.632C18.7795 141.089 28.5716 126.099 32.3714 109.731V109.702L32.3923 109.673L33.2066 108.305L33.217 108.286C33.4676 107.587 33.6972 106.248 33.8747 105.491C34.2401 103.629 35.2214 98.6805 35.5972 96.7497L35.8373 95.5467C36.7455 100.078 37.9773 106.452 38.802 110.973C38.7081 110.731 40.6915 119.152 40.6498 119.103C40.5976 118.958 40.7333 119.288 40.7333 119.278C40.7333 119.288 40.7542 119.317 40.7542 119.336C41.0673 121.5 41.464 123.663 41.819 125.837C42.2679 127.311 42.0904 129.135 41.4954 130.61C39.5015 135.005 36.568 138.964 34.9395 143.514C33.7181 146.493 33.3319 149.646 32.8412 152.78C32.3088 155.913 31.672 159.037 31.1605 162.171C29.0518 174.658 28.0705 187.601 31.3275 199.981L31.3693 199.99Z",
    fill: "url(#paint0_linear_953_3368)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M123.162 173.649C123.162 173.649 123.11 173.629 123.078 173.629C123.037 173.629 122.995 173.639 122.974 173.678C122.964 173.688 122.964 173.697 122.953 173.707C122.348 174.473 121.847 174.9 121.262 174.706C121.21 174.687 121.168 174.697 121.137 174.726C121.095 174.745 121.085 174.794 121.085 174.832C121.178 175.822 120.803 177.665 120.437 179.46L120.375 179.751C120.364 179.819 120.406 179.878 120.479 179.897H120.5C120.563 179.897 120.615 179.858 120.625 179.8C121.366 176.977 122.149 175.143 123.162 173.853C123.172 173.853 123.172 173.833 123.183 173.814C123.225 173.765 123.214 173.688 123.162 173.649ZM121.126 177.277C121.272 176.375 121.377 175.57 121.356 174.978C121.669 175.036 121.972 174.939 122.233 174.774C121.836 175.473 121.471 176.288 121.126 177.277Z",
    fill: "url(#paint1_linear_953_3368)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84803 174.328C6.84803 174.328 6.85847 174.357 6.86891 174.367C7.88152 175.657 8.66446 177.491 9.40565 180.314C9.41609 180.372 9.46828 180.411 9.53092 180.411H9.5518C9.62487 180.392 9.66663 180.334 9.65619 180.266L9.59355 179.975C9.22818 178.18 8.85237 176.336 8.94632 175.347C8.94632 175.308 8.93588 175.259 8.89413 175.24C8.86281 175.211 8.82105 175.201 8.76885 175.22C8.18426 175.415 7.68317 174.988 7.0777 174.221C7.0777 174.211 7.0777 174.202 7.05682 174.192C7.03594 174.153 6.99418 174.144 6.95242 174.144C6.92111 174.144 6.88979 174.144 6.86891 174.163C6.81671 174.202 6.80627 174.279 6.84803 174.328ZM7.798 175.288C8.05898 175.453 8.36172 175.55 8.6749 175.492C8.65402 176.084 8.75841 176.889 8.90456 177.792C8.56007 176.802 8.19469 175.987 7.798 175.288Z",
    fill: "url(#paint2_linear_953_3368)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0039 199.99C58.2923 193.616 60.3592 186.698 61.0378 179.664C61.2257 179.14 61.6641 178.646 62.2383 178.393C63.9399 177.763 65.6728 178.801 67.0717 179.548C67.3118 183.079 67.9173 186.611 68.8046 190.065C69.6711 193.48 70.8924 196.827 72.521 200C70.6941 197.138 69.504 193.461 68.5019 190.133C67.5415 186.718 66.8629 183.244 66.5393 179.713L66.6646 179.917C65.4118 179.257 63.8981 178.355 62.468 178.859C62.0608 179.043 61.7477 179.383 61.5598 179.8L61.5806 179.723C60.7037 186.718 58.5324 193.868 55.0039 200V199.99Z",
    fill: "url(#paint3_linear_953_3368)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7316 67.3133L63.3767 67.0125C63.5124 66.8767 63.5332 66.6924 63.5228 66.5759C63.5124 66.3237 63.3767 66.0617 63.1783 65.8968C62.8129 65.5863 62.2701 65.4699 61.7481 65.3535C57.4994 64.4609 53.355 63.2481 49.3672 61.7346L49.5447 61.3174C53.5011 62.8212 57.6246 64.0243 61.8003 64.8975C62.4058 65.0333 63.0322 65.1788 63.4915 65.5669C63.7838 65.8192 63.9821 66.1879 63.9926 66.5565C64.003 66.8573 63.9091 67.1193 63.7212 67.323L63.7316 67.3133Z",
    fill: "url(#paint4_linear_953_3368)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6442 67.6529C66.3832 67.0126 66.8008 66.3043 67.3437 65.9356C67.8656 65.5864 68.5337 65.4893 69.1288 65.402L78.0961 64.0534C79.2444 63.8691 80.3823 63.6944 81.2905 63.1511L81.5515 63.5295C80.5597 64.1213 79.3697 64.3057 78.2214 64.49L69.2436 65.8483C68.6381 65.9356 68.0535 66.023 67.6255 66.314C67.2393 66.576 66.9156 67.0805 67.0931 67.5074L66.6442 67.6626V67.6529Z",
    fill: "url(#paint5_linear_953_3368)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M100.34 168.94C100.86 168.752 101.128 168.179 100.94 167.66C100.752 167.14 100.179 166.872 99.6598 167.06L100.34 168.94ZM31.0897 169.849C31.6115 170.03 32.1812 169.754 32.3621 169.232C32.5429 168.71 32.2666 168.14 31.7447 167.96L31.0897 169.849ZM36.6147 169.445C36.0814 169.301 35.5327 169.617 35.3893 170.151C35.2458 170.684 35.5619 171.233 36.0952 171.376L36.6147 169.445ZM41.1777 172.591C41.7181 172.705 42.2486 172.359 42.3626 171.819C42.4766 171.278 42.131 170.748 41.5906 170.634L41.1777 172.591ZM46.6333 171.569C46.088 171.481 45.5749 171.852 45.4873 172.397C45.3996 172.943 45.7706 173.456 46.3159 173.543L46.6333 171.569ZM51.4773 174.251C52.026 174.314 52.5216 173.92 52.5841 173.371C52.6467 172.822 52.2526 172.327 51.7039 172.264L51.4773 174.251ZM56.8093 172.73C56.2583 172.693 55.7809 173.109 55.743 173.659C55.7051 174.21 56.121 174.688 56.672 174.726L56.8093 172.73ZM61.8835 174.967C62.4356 174.98 62.8939 174.543 62.9071 173.991C62.9202 173.439 62.4833 172.981 61.9312 172.968L61.8835 174.967ZM67.0568 172.974C66.5046 172.986 66.0667 173.443 66.0786 173.995C66.0905 174.547 66.5477 174.985 67.0999 174.973L67.0568 172.974ZM72.3107 174.741C72.8617 174.703 73.278 174.226 73.2405 173.675C73.203 173.124 72.7259 172.708 72.1749 172.745L72.3107 174.741ZM77.2747 172.277C76.7261 172.34 76.3329 172.837 76.3966 173.385C76.4603 173.934 76.9566 174.327 77.5052 174.263L77.2747 172.277ZM82.6718 173.536C83.2166 173.445 83.585 172.93 83.4945 172.386C83.4041 171.841 82.8891 171.472 82.3443 171.563L82.6718 173.536ZM87.371 170.598C86.8314 170.716 86.4895 171.249 86.6073 171.789C86.7251 172.328 87.258 172.67 87.7976 172.552L87.371 170.598ZM92.8687 171.307C93.4014 171.162 93.7152 170.612 93.5696 170.079C93.424 169.546 92.8741 169.232 92.3413 169.378L92.8687 171.307ZM97.241 167.898C96.7167 168.072 96.4326 168.638 96.6064 169.162C96.7802 169.686 97.346 169.97 97.8703 169.796L97.241 167.898ZM28.6239 168.927C29.3694 169.229 30.1932 169.539 31.0897 169.849L31.7447 167.96C30.8776 167.659 30.0865 167.362 29.3761 167.073L28.6239 168.927ZM36.0952 171.376C37.6659 171.799 39.3647 172.208 41.1777 172.591L41.5906 170.634C39.8127 170.259 38.1494 169.858 36.6147 169.445L36.0952 171.376ZM46.3159 173.543C47.9695 173.809 49.6925 174.048 51.4773 174.251L51.7039 172.264C49.95 172.064 48.2572 171.83 46.6333 171.569L46.3159 173.543ZM56.672 174.726C58.3673 174.842 60.1064 174.925 61.8835 174.967L61.9312 172.968C60.1847 172.926 58.4755 172.845 56.8093 172.73L56.672 174.726ZM67.0999 174.973C68.8101 174.937 70.5485 174.86 72.3107 174.741L72.1749 172.745C70.4444 172.863 68.7369 172.938 67.0568 172.974L67.0999 174.973ZM77.5052 174.263C79.2112 174.065 80.9347 173.824 82.6718 173.536L82.3443 171.563C80.6403 171.846 78.9492 172.082 77.2747 172.277L77.5052 174.263ZM87.7976 172.552C89.48 172.185 91.1714 171.771 92.8687 171.307L92.3413 169.378C90.6783 169.832 89.0204 170.238 87.371 170.598L87.7976 172.552ZM97.8703 169.796C98.6931 169.524 99.5166 169.238 100.34 168.94L99.6598 167.06C98.8533 167.351 98.0469 167.631 97.241 167.898L97.8703 169.796Z",
    fill: "#EB6262"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_953_3368",
    x1: 64.6282,
    y1: 183.793,
    x2: 64.9436,
    y2: 0.931262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0856476
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752742
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898013,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_953_3368",
    x1: 121.794,
    y1: 187.251,
    x2: 121.794,
    y2: 158.252,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_953_3368",
    x1: 8.24689,
    y1: 187.765,
    x2: 8.24689,
    y2: 158.766,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#D6D6D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#131313"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#575757"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#BABABA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_953_3368",
    x1: 63.7624,
    y1: 198.962,
    x2: 63.7624,
    y2: 159.319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#A8A8A8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#878787"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#111111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#262626"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#444444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#6B6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#9B9B9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#D1D1D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_953_3368",
    x1: 49.3672,
    y1: 64.3153,
    x2: 64.003,
    y2: 64.3153,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_953_3368",
    x1: 66.5711,
    y1: 65.402,
    x2: 81.5619,
    y2: 65.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#B9B9B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#8D8D8D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#676767"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#474747"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#2D2D2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#020202"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#0A0A0A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#171717"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#2A2A2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#616161"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#B0B0B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#DEDEDE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFHUnisex);
export default __webpack_public_path__ + "static/media/F_h_unisex.9fe527776600e65e735df5f316d0a173.svg";
export { ForwardRef as ReactComponent };